import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { HStack, theme, useResponsive, VStack } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsIngredientsStack = (props: Props) => {
  const { children } = props;

  const { minWidth } = useResponsive();

  if (minWidth.isLG) {
    return (
      <HStack style={styles.stack} gap={theme.spacing['15']}>
        {children}
      </HStack>
    );
  }

  return (
    <VStack gap={theme.spacing['10']} style={[styles.stack, styles.stackXS]}>
      {children}
    </VStack>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  stack: {
    alignSelf: 'flex-start',
  },
  stackXS: {
    maxWidth: '100%',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
